import React, { useState, useRef, useEffect } from 'react';
import mcProceso from '../assets/mcProceso.png';

const ZoomImage = () => {
    const [lensPosition, setLensPosition] = useState({ x: 0, y: 0 });
    const [isZoomActive, setIsZoomActive] = useState(false);
    const [isZoomEnabled, setIsZoomEnabled] = useState(true);
    const imgRef = useRef(null);
    const lensRef = useRef(null);
    const zoomRef = useRef(null);

    useEffect(() => {
        // Detectar el ancho de la pantalla y desactivar el zoom si es menor a 700px
        const handleResize = () => {
            if (window.innerWidth < 760) {
                setIsZoomEnabled(false);
            } else {
                setIsZoomEnabled(true);
            }
        };

        // Ejecutar la función al cargar y también cuando la pantalla se redimensione
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleMouseEnter = () => {
        if (isZoomEnabled) {
            setIsZoomActive(true);
        }
    };

    const handleMouseLeave = () => {
        setIsZoomActive(false);
    };

    const handleMouseMove = (e) => {
        if (!isZoomEnabled) return;

        const img = imgRef.current;
        const lens = lensRef.current;
        const zoomResult = zoomRef.current;

        const rect = img.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        let lensX = x - lens.offsetWidth / 2;
        let lensY = y - lens.offsetHeight / 2;

        if (lensX > img.width - lens.offsetWidth) lensX = img.width - lens.offsetWidth;
        if (lensX < 0) lensX = 0;
        if (lensY > img.height - lens.offsetHeight) lensY = img.height - lens.offsetHeight;
        if (lensY < 0) lensY = 0;

        setLensPosition({ x: lensX, y: lensY });

        const cx = zoomResult.offsetWidth / lens.offsetWidth;
        const cy = zoomResult.offsetHeight / lens.offsetHeight;

        zoomResult.style.backgroundPosition = `-${lensX * cx}px -${lensY * cy}px`;
    };

    return (
        <div className="img-zoom-container" style={{ position: 'relative',backgroundRepeat: 'no-repeat' }}>
            <img
                ref={imgRef}
                src={mcProceso}
                alt="Proceso"
                className="zoom-image"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onMouseMove={handleMouseMove}
                style={{ width: '90%'}}
                
            />
            <div
                ref={lensRef}
                className="img-zoom-lens"
                style={{
                    position: 'absolute',
                    border: '1px solid #d4d4d4',
                    width: '100px',
                    height: '100px',
                    visibility: isZoomActive && isZoomEnabled ? 'visible' : 'hidden',
                    left: lensPosition.x,
                    top: lensPosition.y,
                    pointerEvents: 'none'
                }}
            ></div>
            <div
                ref={zoomRef}
                className="img-zoom-result"
                style={{
                    border: '1px solid #d4d4d4',
                    width: '200px',
                    height: '200px',
                    position: 'relative',
                   /* bottom: '-110%',*/
                    left: '16%',
                    backgroundImage: `url(${mcProceso})`,
                    backgroundSize: `${imgRef.current?.width * 1.8}px ${imgRef.current?.height * 1.8}px`,
                    pointerEvents: 'none',
                    visibility: isZoomActive && isZoomEnabled ? 'visible' : 'hidden'
                }}
            ></div>
        </div>
    );
};

export default ZoomImage;